// extracted by mini-css-extract-plugin
export default {"item":"orderCard_item__ie86+","download":"orderCard_download__vA9dd","a_source":"orderCard_a_source__I2Ojq"};